/**
 * Wraps a value in double-quotes and escapes any internal double-quotes.
 * Prevents CSV formula injection when files are opened in spreadsheet applications.
 */
function csvQuote(value) {
  const str = value == null ? '' : String(value);
  return '"' + str.replace(/"/g, '""') + '"';
}

/**
 * Export rankings data as CSV download.
 */
function ExportButton({ rankings, aggregated }) {
  function handleExport() {
    let csv;
    if (aggregated) {
      const sourceNames = [];
      const seen = new Set();
      rankings.forEach(r => {
        if (r.ranksBySource) {
          Object.keys(r.ranksBySource).forEach(s => {
            if (!seen.has(s)) { seen.add(s); sourceNames.push(s); }
          });
        }
      });
      sourceNames.sort();

      const headers = ['Avg Rank', 'Player', 'Position', 'Team', ...sourceNames.map(csvQuote), 'High OVR', 'Low OVR', 'High Pos', 'Low Pos', 'StdDev'];
      csv = headers.join(',') + '\n';
      csv += rankings.map(r => {
        const sourceRanks = sourceNames.map(s => r.ranksBySource?.[s] ?? '');
        return [r.avgRank, csvQuote(r.playerName), csvQuote(r.position), csvQuote(r.team), ...sourceRanks, r.highOvrRank, r.lowOvrRank, r.highRank, r.lowRank, r.stdDev].join(',');
      }).join('\n');
    } else {
      csv = 'Rank,Player,Position,Team,Source\n';
      csv += rankings.map(r =>
        [r.rank, csvQuote(r.playerName), csvQuote(r.position), csvQuote(r.team), csvQuote(r.source)].join(',')
      ).join('\n');
    }

    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = aggregated ? 'consensus-rankings.csv' : 'rankings.csv';
    a.click();
    URL.revokeObjectURL(url);
  }

  return (
    <button className='btn btn-secondary' onClick={handleExport} disabled={rankings.length === 0}>
      Export CSV
    </button>
  );
}

export default ExportButton;
